const getUserData = () => {
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  let localUserData;

  try {
    localUserData = JSON.parse(localStorage.getItem("userData")) || {};
  } catch (error) {
    localUserData = {};
  }

  const isUserDataCorrect = localUserData && Object.keys(localUserData).length !== 0 && localUserData.hasOwnProperty("username") && localUserData.hasOwnProperty("email")

  const token = getCookie('token');

  const productSku = localStorage.getItem("wp_product_sku");

  return {token, localUserData, isUserDataCorrect, productSku}
}

export default getUserData